(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TYPE_SPEED = 50;     // ms pro Zeichen beim Tippen
  const DELETE_SPEED = 35;   // ms pro Zeichen beim Löschen
  const HOLD = 1000;         // Pause vollständiger Text
  const GAP = 400;           // Pause nächster Begriff

  function initTypewriter(input) {
    if (input.dataset.typewriterInit) return;

    const phrases = (input.dataset.placeholderPhrases || '')
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (!phrases.length) return;

    input.dataset.typewriterInit = 'true';
    const fallback = input.getAttribute('placeholder') || '';

    let phraseIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = null;
    let visible = false;

    const schedule = (delay) => {
      timer = setTimeout(tick, delay);
    };

    function tick() {
      const phrase = phrases[phraseIndex];

      if (!deleting) {
        charIndex++;
        input.setAttribute('placeholder', phrase.slice(0, charIndex));
        if (charIndex >= phrase.length) {
          deleting = true;
          schedule(HOLD);
        } else {
          schedule(TYPE_SPEED);
        }
        return;
      }

      charIndex--;
      input.setAttribute('placeholder', phrase.slice(0, charIndex));
      if (charIndex <= 0) {
        deleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        schedule(GAP);
      } else {
        schedule(DELETE_SPEED);
      }
    }

    function start() {
      if (timer || !visible || input.value) return;
      schedule(GAP);
    }

    // Unsichtbar: anhalten, Fortschritt behalten
    function pause() {
      clearTimeout(timer);
      timer = null;
    }

    // Eingabe: anhalten und statischen Platzhalter setzen
    function reset() {
      pause();
      charIndex = 0;
      deleting = false;
      input.setAttribute('placeholder', fallback);
    }

    input.addEventListener('input', () => {
      input.value ? reset() : start();
    });

    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      visible ? start() : pause();
    }).observe(input);
  }

  const initAll = () =>
    document.querySelectorAll('input[data-placeholder-phrases]').forEach(initTypewriter);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();